import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiSvgIcon } from '@material-ui/core/SvgIcon';
import clsx from 'clsx';
import { makeStyles, createStyles } from '@material-ui/core/styles';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        strokeIcon: {
            fill: 'none',
        },
        directionalIcon: __assign({}, (theme.direction === 'rtl'
            ? {
                transform: 'scaleX(-1)',
            }
            : {})),
    });
});
export var SvgIcon = React.forwardRef(function (props, ref) {
    var fontSize = props.fontSize, titleAccess = props.titleAccess, viewBox = props.viewBox, className = props.className, isColor = props.isColor, classesProp = props.classes, isDirectional = props.isDirectional, other = __rest(props, ["fontSize", "titleAccess", "viewBox", "className", "isColor", "classes", "isDirectional"]);
    var classes = useStyles(props);
    var viewBoxValue = '0 0 24 24';
    var classNames = clsx(isDirectional && classes.directionalIcon, !isColor && classes.strokeIcon, className);
    if (fontSize === 'small') {
        viewBoxValue = '0 0 16 16';
    }
    else if (fontSize === 'large') {
        viewBoxValue = '0 0 38 38';
    }
    viewBoxValue = viewBox || viewBoxValue;
    return (React.createElement(MuiSvgIcon, __assign({ className: classNames, viewBox: viewBoxValue, fontSize: fontSize, classes: classesProp, ref: ref }, other, { "aria-hidden": titleAccess ? undefined : true, role: titleAccess ? 'img' : 'presentation', "aria-label": titleAccess })));
});
export default SvgIcon;
//# sourceMappingURL=SvgIcon.js.map